// extracted by mini-css-extract-plugin
export default {"wrapper":"aB-z","viewport":"bB-z","container":"cB-z","slide":"dB-z"};